import React from 'react'
import { HomeContainer, Title } from './home.styles'



const Home = () => {
    return (
        <HomeContainer>
                <Title >Welcome to The Movies</Title>
        </HomeContainer>
    )
}

export default Home; 
